import { DEAL_LOADING, GET_DEAL, GET_DEAL_SUCCESS, GET_DEAL_FAIL, ADD_DEAL_SUCCESS, ADD_DEAL_FAIL, DELETE_DEAL_SUCCESS, DELETE_DEAL_FAIL, UPDATE_DEAL, UPDATE_DEAL_SUCCESS, UPDATE_DEAL_FAIL, DEAL_RESET } from "./actionType";

const INIT_STATE = {
  deals: [],
  error: {},
};

const Deal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_DEAL:
          return {
            ...state,
            deals: action.payload.data,
            isDealCreated: false,
            isDealSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_DEAL_FAIL:
      switch (action.payload.actionType) {
        case GET_DEAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isDealCreated: false,
            isDealSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_DEAL: {
      return {
        ...state,
        isDealCreated: false,
        loading: true,
      };
    }

    case DEAL_LOADING: {
      return {
        ...state,
        isDealCreated: false,
        loading: true,
      };
    }

    case ADD_DEAL_SUCCESS:
      return {
        ...state,
        isDealCreated: true,
        loading: false,
        deals: [action.payload.data, ...state.deals],
      };

    case ADD_DEAL_FAIL:
      return {
        ...state,
        loading: false,
        isDealCreated: false,
        error: action.payload,
      };

    case DELETE_DEAL_SUCCESS:
      return {
        ...state,
        loading: false,
        isDealCreated: true,
        deals: state.deals.filter((deal) => deal.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_DEAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DEAL:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_DEAL_SUCCESS:
      return {
        ...state,
        loading: false,
        isDealCreated: true,
        deals: state.deals.map((deal) => (deal.id.toString() === action.payload.data.id.toString() ? { ...deal, ...action.payload.data } : deal)),
      };

    case UPDATE_DEAL_FAIL:
      return {
        ...state,
        loading: false,
        isDealCreated: false,
        error: action.payload,
      };

    case DEAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Deal;
